import * as Api from '@ViewModels';
import { IRegEdReviewNote, IRegEdSubmissionAnnotation } from '../RegEdCompliance/types';

export type ApprovalHistoryResourceType = 'blog' | 'email' | 'socialPost';

export const ApprovalHistoryResourceUrlSegments: Record<ApprovalHistoryResourceType, string> = {
	blog: 'blog',
	email: 'email',
	socialPost: 'social/post',
};

/** A superseded round. The live one stays on the resource's `approvalRequests`; nothing is in both. */
export interface IApprovalHistoryEntry extends Api.IBaseResourceModel {
	approver?: Api.IUserReference;
	/** Null when the content was revised before the reviewer ever answered. */
	response?: Api.ICampaignApprovalResponse;
	supersededDate?: string;
	/** Only a broker-dealer decision carries these; absent for an internally reviewed piece. */
	reviewNotes?: IRegEdReviewNote[];
	/**
	 * The firm's own word for the outcome. "Revise and Resubmit" and "Declined" both arrive as a
	 * rejected `response`, so this is the only thing that tells them apart.
	 */
	decisionCode?: string | null;
	/** Identity only — the bytes come from the annotation download endpoint, keyed by this id. */
	annotations?: IRegEdSubmissionAnnotation[];
	providerReferenceId?: string | null;
	submittedToProviderAt?: string | null;
}
